import {AppComponent} from './app.component';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {appRouting} from './app.routing';
import {LayoutModule} from './layout/layout.module';
import {NotFoundModule} from './pages/not-found/not-found.module';
import {AuthenticationModule} from './pages/authentication/authentication.module'
import {SociosModule} from './pages/socios/socios.module';
import { CookieService } from "ngx-cookie-service";
import { HttpClientModule } from '@angular/common/http';
import { SharedModule } from './shared/shared.module';

export const COMPONENTS = [
  AppComponent
];

export const IMPORTS = [
  BrowserModule,
  BrowserAnimationsModule,
  appRouting,
  LayoutModule,
  NotFoundModule,
  AuthenticationModule,
  SociosModule,
  SharedModule,
  HttpClientModule
];

export const SERVICES = [
  CookieService
];
